const setBodyScroll = (modalShow) => {
    if(modalShow) {
        document.body.style.overflow = "hidden";
    }
    else {
        document.body.style.overflow = "unset";
    }
};

export default setBodyScroll;